
export const fromRoleDTO = ({
    id,
    name,
}) => ({
    id,
    name,
})

export const fromRolesDTO = (roles) => roles.map((role) => fromRoleDTO(role))
